import { queryParamHookFactory } from '../../../../../../taboola-common-frontend-modules/query-params';

export const BULK_EDIT_CREATIVES_SHARED_VALUES = 'bulkEditCreativesSharedValues';
export const useBulkEditCreativesSharedValues = queryParamHookFactory(BULK_EDIT_CREATIVES_SHARED_VALUES);
